export default {
	'Search': 'Ieškoti',
	'Check in': 'Atvykimas',
	'Check Out': 'Išvykimas',
	'Terms and Conditions': ' Sąlygos ir Nuostatos',
	'Privacy Policy': 'Privatumo politika',
	'Book a co-working space': 'Užsisakykite darbo vietą',
	'day': 'diena',
	'night': 'naktis',
	'Days': 'Dienos',
	'period': 'periodas',
	'week': 'savaitė',
	'weeks': 'savaitės',
	'month': 'mėnuo',
	'months': 'mėnesiai',
	'hour': 'valanda',
	'Hours': 'Valandos',
	'hours': 'valandos',
	'days': 'dienos',
	'guests': 'svečių', // eg "100 guests"
	'access to coworking': 'prieiga prie darbo vietų',
	'Description': 'Aprašymas',
	'Free cancellation': 'Nemokamas atšaukimas',
	'Location': 'Lokacija',
	'Add dates for prices': 'Pasirinkite datas',
	'Total': 'Iš viso',
	'Inquire': 'Teirautis',
	'Book Now': 'Užsakyti',
	'Room': 'Kambarys',
	'Request for availability': 'Prašymas dėl prieinamumo',
	'Please fill contact form': 'Prašome užpildyti kontaktinę formą',
	'Refine your booking': 'Patikslinkite rezervaciją',
	'Your booking details': 'Jūsų rezervacijos duomenys',
	'Booking summary': 'Užsakymo santrauka',
	'Checkout': 'Apmokėjimas',
	'Need more rooms?': 'Reikia daugiau kambarių?',
	'Add Room': 'Pridėti kambarį',
	'Add room': 'Pridėti kambarį',
	'We will hold your reservation until you add all rooms you need.': 'Išsaugosime jūsų rezervaciją, kol pridėsite visus jums reikalingus kambarius.',
	'Summary': 'Santrauka',
	'Services': 'Paslaugos',
	'Proceed to checkout': 'Pereiti prie apmokėjimo',
	'Check-in': 'Atvykimas',
	'Check-out': 'Išvykimas',
	'Rooms': 'Kambariai',
	'room': 'Kambarys',
	'Quantity': 'Trukmė',
	'Price (taxes incl.)': 'Kaina (su mokesčiais)',
	'remove reservation': 'Pašalinti rezervaciją',
	'remove': 'pašalinti',
	'Contact information': 'Kontaktinė informacija',
	'Name': 'Vardas',
	'Last name': 'Pavardė',
	'Email': 'El. paštas',
	'Your phone': 'Jūsų telefonas',
	'Company': 'Įmonė',
	'Company code': 'Įmonės kodas',
	'Company address': 'Įmonės adresas',
	'Company VAT code': 'Įmonės PVM kodas',
	'Have a discount code?': 'Turite nuolaidos kodą?',
	'Discount code': 'Nuolaidos kodas',
	'Apply': 'Taikyti',
	'I accept': 'Aš sutinku',
	'and': 'ir',
	'I agree to get marketing info. I may unsubscribe anytime.': 'Sutinku gauti rinkodaros informaciją. Galėsite bet kada atsisakyti prenumeratos.',
	'Pay': 'Mokėti',
	'Booking details': 'Rezervacijos informacija',
	'VAT': 'PVM',
	'Total (taxes incl.)': 'Iš viso (su mokesčiais)',
	'Check-Out': 'Išsiregistruoti',
	'Required': 'Privalomas',
	'Must be an email': 'Turi būti El. paštas',
	'It appears that this discount code is invalid.': 'Pasirodo, kad šis nuolaidos kodas neteisingas.',
	'Discount code applied': 'Nuolaidos kodas pritaikytas',
	'It is not available during selected dates': 'Nepasiekiama pasirinktomis dienomis',
	'Request': 'Prašymas',
	'Failed reservation': 'Nepavyko rezervuoti',
	'There was a problem and we were not able to complete your reservation order. Possible reasons why order failed are:': 'Iškilo problema ir mes negalėjome įvykdyti jūsų rezervacijos užsakymo. Galimos priežastys, kodėl nepavyko užsakyti:',
	'a billing error caused by your bank': 'Atsiskaitymo klaida, kurią sukėlė jūsų bankas',
	'insufficient credit on your account': 'Nepakankamas kreditas jūsų sąskaitoje',
	'your credit card is expired': 'Baigėsi jūsų kredito kortelės galiojimo laikas',
	'booking was cancelled or expired': 'užsakymas buvo atšauktas arba pasibaigęs',
	'Your booking reservation': 'Jūsų užsakymo rezervacija',
	'Booking confirmation was sent to you by email at': 'Užsakymo patvirtinimas buvo išsiųstas jums el. paštu',
	'Hello there,': 'Sveiki,',
	'Thank you for booking with us. We are looking forward to welcoming you.': 'Dėkojame, kad užsisakėte pas mus. Nekantriai laukiame jūsų.',
	'If you have any questions or preferences for your stay please get in touch': 'Jei turite klausimų ar pageidavimų dėl viešnagės, susisiekite',
	'Your payment failed': 'Jūsų mokėjimas nepavyko',
	'Unfortunately, we couldn\'t collect payment on your purchase. Please take a moment to review your billing information - if it looks correct, please': 'Deja, negalime priimti mokėjimo už pirkinį. Skirkite šiek tiek laiko ir peržiūrėkite atsiskaitymo informaciją, jei ji atrodo teisinga',
	'to let us know. Otherwise, please update your information': 'Praneškite mums. Kitu atveju atnaujinkite savo informaciją',
	'f you have any questions about your checkout,': 'jei turite klausimų dėl atsiskaitymo,',
	'and we\'ll get right back to you.': 'ir mes tuoj su jumis susisieksime.',
	'Upon arrival': 'Atvykus',
	'here to find us': 'mus galite rasti',
	'There are plenty of public parking places at the location.': 'Vietoje yra daug viešų automobilių stovėjimo vietų.',
	'NotFound': 'Resursas nerastas',
	'BookingOneOrMoreProductsUnavailable': 'Nėra laisvų lovų kambaryje',
	'CoworkingOrConferenceRoomBookingOneOrMoreProductsUnavailable': 'Nėra laisvų kambarių',
	'DuplicateOrder': 'Atrodo, kad jūsų užsakymas jau pateiktas! Nenorime apmokestinti daugiau nei jau užsisakėte :)',
	'BookingExpired': 'Panašu, kad jūsų užsakymas baigėsi, pradėkite iš naujo.',
	'IncorrectBookingCheckOutDate': 'Neteisinga užsakymo išsiregistravimo data.',
	'Amenities': 'Patogumai',
	'persons': 'vietos',
	'Getting here': 'Kaip atvykti',
	'Extras and upgrades': 'Papildomi priedai',
	'Extras': 'Priedai',
	'unit': 'vienetas',
	'person': 'asm.',
	'City tax': 'Miesto mokestis',
	'Country': 'Šalis',
	'Date of birth': 'Gimimo data',
	'I agree to get marketing info.': 'Sutinku gauti rinkodaros informaciją.',
	'Discount code applied.': 'Nuolaidos kodas pritaikytas.',
	'There was a problem and we were not able to complete your reservation order. Possible reasons why order failed are,': 'Kilusios problemos negalėjome užbaigti jūsų rezervacijos užsakymo. Galimos priežastys, kodėl užsakymas nepavyko:',
	'Total paid': 'Iš viso sumokėta',
	'Total due (taxes incl.)': 'Iš viso sumokėti (su mokesčiais)',
	'Check-In': 'Registracija',
	'Minimum stay duration': 'Minimalus viešnagės laikotarpis',
	'Maximum stay duration': 'Maksimalus viešnagės laikotarpis',
	'It seems that your booking has expired, please, start over.': 'Atrodo, kad jūsų rezervacija pasibaigė, prašome pradėti iš naujo.',
	'InvalidBooking': 'NegaliojantiRezervacija',
	'BookingHasUnavailableProducts': 'RezervacijaTuriNepasiekiamųProduktų',
	'BookingAlreadyCheckedOut': 'RezervacijaJauApmokėta',
	'BookingAlreadyDeleted': 'RezervacijaJauPašalinta',
	'BookingExpectedAllBookingProductsToHaveReservation': 'ReikiaVisiemsRezervuojamiemsProduktamsTuretiRezervaciją',
	'ColivingBookingCheckoutMissingDeliveryMethod': 'BendravimoRezervacijosApmokėjimoTrūkstaPristatymoBūdo',
	'DurationIsTooShort': 'LaikotarpisPerTrumpas',
	'DurationIsTooLong': 'LaikotarpisPerIlgas',
	'DurationIsNegativeOrZero': 'LaikotarpisNeigiamasArbaNulis',
	'BookingNothingToInvoice': 'RezervacijaNėraKąSąskaituoti',
	'InvalidAvailabilityRange': 'NegaliojantisPrieinamumoIntervalas',
	'InvalidAvailabilityRangeExceedsTwoCalendarMonths': 'NegaliojantisPrieinamumoIntervalasViršijaDviKalendorinesMenesio',
	'MinDurationMustBe1day': 'MinimalusLaikotarpisTuriBūti1Diena',
	'BookingShouldHaveAtLeastOneBookableProduct': 'RezervacijaTurėtųTurėtiMažiausiaiVienąRezervuojamąProduktą',
	'PayseraIntegrationDisabled': 'PayseraIntegracijaIšjungta',
	'CheckoutCreationFailed': 'ApmokėjimoKūrimasNepavyko',
	'CheckoutPriceCalculationFailed': 'ApmokėjimoKainosSkaičiavimasNepavyko',
	'ValidationError': 'Validacijos klaida',
	'Hello there': 'Sveiki',
	'Your booking has been updated. Please, review the newly added items and proceed with a follow-up payment.': 'Jūsų rezervacija buvo atnaujinta. Prašome peržiūrėti naujai pridėtas prekes ir tęsti mokėjimą.',
	'Customer': 'Klientas',
	'Your order online': 'Jūsų užsakymas internetu',
	'Added items': 'Pridėtos prekės',
	'Beds': 'Lova',
	'Night': 'Naktis',
	'Book again': 'Užsisakykite dar kartą',
	'Booking updated': 'Rezervacija atnaujinta',
	'Thanks for booking.': 'Ačiū už užsakymą.',
	'Booking confirmation': 'Rezervacijos patvirtinimas',
	'Click here to View Order online': 'Spustelėkite čia, norėdami peržiūrėti užsakymą internetu',
	'Discount': 'Nuolaida',
	'discount': 'nuolaida',
	'Submit': 'Pateikti',
	'Cancel': 'Atšaukti',
	'Add': 'Pridėti',
	'Thank you, your inquiry has been received and is being processed. Someone will contact you as soon as possible!': 'Ačiū, jūsų užklausa gauta ir apdorojama. Kažkas su jumis susisieks kuo skubiau!',
	'Back to main page after': 'Grįžti į pagrindinį puslapį po',
	'seconds': 'sekundžių',
	'Accept': 'Priimti',
	'Reservation removed successfully': 'Rezervacija sėkmingai pašalinta',
	'Your booking expired': 'Jūsų rezervacija pasibaigė',
	'Search for Room': 'Ieškoti kambario',
	'We hold bookings for 15 minutes.': 'Mes išsaugojame rezervacijas 15 minučių.',
	'select season': 'pasirinkite sezoną',
	'Select season': 'Pasirinkite sezoną',
	'Season': 'Sezonas',
	'Deposit': 'Depozitas',
	'Due Today': 'Mokėtina suma',
	'Gender': 'Lytis',
	'University': 'Universitetas',
	'Stay purpose': 'Viešnagės tikslas',
	'Phone': 'Telefonas',
	'Study year': 'Mokslo metai',
	'Faculty': 'Fakultetas',
	'Type of study program': 'Mokymo programos tipas',
	'Study': 'Studijos',
	'Work': 'Darbas',
	'Leisure': 'Poilsis',
	'Exchange (Erasmus 5 months)': 'Mainai (Erasmus 5 mėnesiai)',
	'Exchange (Erasmus 10 months)': 'Mainai (Erasmus 10 mėnesiai)',
	'Full-time': 'Nuolatinės studijos',
	'Remove': 'Pašalinti',
	'Male': 'Vyras',
	'Female': 'Moteris',
	'Other': 'Kita',
	'Must be only digits': 'Turi būti tik skaitmenys',
	'Phone number is not valid': 'Netinkamas telefono numeris',
	'Incorrect format. Allowed symbols: 0-9': 'Neteisingas formatas. Leidžiami simboliai: 0-9',
	'bed': 'lova',
	'Nights': 'Naktys',
	'nights': 'naktys',
	'We are now accepting reservations': 'Dabar priimame rezervacijas',
	'Address': 'Adresas',
	'Additional person': 'Papildomas asmuo',
	'Minimum stay is': 'Minimali viešnagė yra',
	'Minimum duration': 'Minimalus laikotarpis',
	'Maximum duration': 'Maksimalus laikotarpis',
	'Back to search': 'Atgal į paiešką',
	'Birthday': 'Gimimo diena',
	'Actual arrival date': 'Atvykimo data',
};
